module.exports = __webpack_public_path__ + "img/cover.f5631b47.jpg";